import { bypassConverter, dateConverter, dateTimeConverter, ensureNumberConverter } from '@shared/excel/converters';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { ConverterOptions, ValueConverter } from 'shared/execution/types';
import { DataField } from 'shared/providers/types';

dayjs.extend(utc);
dayjs.extend(timezone);

export class HubspotValueConverter implements ValueConverter {
  constructor() {}

  toProviderValue(value: any, field: DataField, options: ConverterOptions): any {
    const { type } = field;

    if (type === 'enumeration') {
      const option = field.options?.find((option) => option.label === value || option.value === value);
      if (option) {
        return { value: option.value };
      }
      return { value: option };
    }

    if (type === 'number') {
      return ensureNumberConverter(type, value);
    }

    if (type === 'date') {
      return dateConverter(value);
    }

    if (type === 'datetime') {
      const { value: convertedValue, error } = dateTimeConverter(value);
      if (error) {
        return { error };
      }
      return { value: dayjs.tz(convertedValue, options.timezone).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ') };
    }

    return bypassConverter(value);
  }

  toExcelValue(value: any, field: DataField, options: ConverterOptions): any {
    if ((field.type === 'datetime' || field.type === 'date') && typeof value === 'string') {
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return value;
      }

      const { timezone } = options;

      return dayjs(date)
        .tz(timezone)
        .format(field.type === 'datetime' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD');
    }

    if (field.type === 'enumeration') {
      const option = field.options?.find((option) => option.value === value);

      if (option) {
        return option.label;
      }

      return option;
    }

    return value;
  }
}
